import { createContext, useCallback, useContext, useState } from "react";
import LeadModal from "./LeadModal";

const LeadModalCtx = createContext({ open: () => {}, close: () => {} });

export function useLeadModal() {
  return useContext(LeadModalCtx);
}

export default function LeadModalProvider({ children }) {
  const [isOpen, setOpen] = useState(false);
  const [intent, setIntent] = useState("contact"); // "contact" | "sales" | "started"

  const open = useCallback((nextIntent = "contact") => {
    setIntent(nextIntent);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <LeadModalCtx.Provider value={{ open, close }}>
      {children}
      <LeadModal isOpen={isOpen} onClose={close} intent={intent} />
    </LeadModalCtx.Provider>
  );
}
